import { useTranslation } from 'libs/i18n';
import { IconButton } from 'libs/ui';
import { Icon } from 'libs/ui/Icon';
import { Section } from 'modules/client/common/components';

import { useFormContext } from '../../../forms/citizenshipForm';

import { FormContent, FormContentProps } from './FormContent';

interface Props extends Omit<FormContentProps, 'onRemoveCitizenship'> {}

export const CitizenshipSection = ({ ...formProps }: Props) => {
  const { t } = useTranslation();
  const { readOnly, values, setFieldValue } = useFormContext();

  const onAddCitizenship = () => {
    const citizenships = [...values.citizenships, null];
    setFieldValue('citizenships', citizenships, false);
  };

  const onRemoveCitizenship = (index: number) => {
    const citizenships = [...values.citizenships];
    citizenships.splice(index, 1);
    setFieldValue('citizenships', citizenships, false);
  };

  return (
    <Section
      datax="citizenshipSection"
      headerRight={
        !readOnly && (
          <IconButton
            icon={<Icon.Plus size={16} />}
            mode="outlined"
            sizeVariant="xs"
            onClick={onAddCitizenship}
          />
        )
      }
      title={t('client.client.citizenship.title')}
    >
      <FormContent {...formProps} onRemoveCitizenship={onRemoveCitizenship} />
    </Section>
  );
};
